import { NgModule } from "@angular/core";
import { AuthenticationService } from "app/services/authentication.service";

import {RestService} from "./rest.service";
import {RestAbstractService} from "./abstract/rest.abstract.service";
import {UserService} from "../user.service";
import {LoginService} from "./login.service";

@NgModule({
    providers: [
        { provide: RestAbstractService,  useClass: RestService },
        { provide: "Auth", useClass: AuthenticationService },
        RestService,
        AuthenticationService,
        LoginService,
        UserService,
    ]
})
export class RestModule { }
